module.exports = __webpack_public_path__ + "media/images/communities/logos/ao13-d46e9a37ecaf9a1e4be3f8e7c1adc27f.jpg";